/* unplugin-vue-components disabled */import { render } from "./no-privilege.vue?vue&type=template&id=2f06c076"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__